export default __webpack_public_path__ + "static/academicEnglishCard-5604b29998207703216ba294d4f87ea5.png";